import {Injectable} from '@angular/core';
import { NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class TimeNativeAdapter extends NgbTimeAdapter<Date> {
    date:Date;

    fromModel(date: Date): NgbTimeStruct {
        this.date = date;
        return (date instanceof Date && !isNaN(date.getTime())) ? this._fromNativeDate(date) : null;
    }

    toModel(date: NgbTimeStruct): Date {
        return this._toNativeDate(date);
    }

    protected _fromNativeDate(date: Date): NgbTimeStruct {
        return {hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds()};
    }

    protected _toNativeDate(date: NgbTimeStruct): Date {
        this.date.setHours(date.hour);
        this.date.setMinutes(date.minute);
        this.date.setSeconds(date.second);
        return this.date;
    }
}